module.exports = {
	"pathContext": {}
};


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/contact.json
// module id = ./node_modules/json-loader/index.js!./.cache/json/contact.json
// module chunks = 12102049724633889000